<template>
    <v-card>
        <v-card-title>
            {{$t('evoucher.add')}}
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="$router.push({name: 'evoucher-guests-template', params: {isTemplate: 1}})">
                Excel Template
                <v-icon right>mdi-download</v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text>
            <v-container fluid>
                <v-row>
                    <v-file-input
                        outlined
                        prepend-icon=""
                        prepend-inner-icon="$file"
                        accept=".xlsx, .xls, .csv"
                        label="Import File"
                        placeholder="Select..."
                        @change="uploadExcel"></v-file-input>
                </v-row>
                <v-row>
                    <v-chip
                        label
                        small
                        @click="addEvoucher">
                        <v-icon>mdi-account-plus</v-icon>
                    </v-chip>
                    <v-chip
                        label
                        small
                        @click="removeEvoucher">
                        <v-icon>mdi-account-minus</v-icon>
                    </v-chip>
                </v-row>
                <v-row>
                    <canvas-datagrid
                        :data.prop="excelData"
                        @rendercell="loadDataCheck"
                        @beforesortcolumn="beforeSortColumn"
                        style="height: 300px"
                        id="excelGrid"></canvas-datagrid>
                </v-row>
                <v-row>
                    <br>
                </v-row>
                <v-row>
                    <v-btn color="primary" @click="importCheck">
                        {{$t('evoucher.create')}}
                    </v-btn>
                </v-row>
            </v-container>
        
        </v-card-text>
            
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        
        <v-dialog v-model="dialog" scrollable max-width="640px">
            <v-card>
                <v-card-text style="height: 360px; padding: 15px" v-html="dialogMsg">
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
        <RouterView></RouterView>
    </v-card>
</template>

<script>
    import {computed, ref, onMounted} from '@vue/composition-api';
    
    import XLSX from 'xlsx';
    import CanvasDatagrid from 'canvas-datagrid';
    import _ from 'lodash';
    import eConfig from "../../evention-config.js"

    export default {
        name: 'EventEvoucherGuestsBatchAdd',
        setup(props, {root}) {
            const {EvoucherGuest, EventGuest, Merchant} = root.$FeathersVuex.api;
            
            onMounted(() => {
                document.getElementById('excelGrid').style.width = '100%';
                document.getElementById('excelGrid').controlInput.onblur = () => {
                    if (document.getElementById('excelGrid') && document.getElementById('excelGrid').input) {
                        document.getElementById('excelGrid').input.onblur = () => {
                            document.getElementById('excelGrid').endEdit(false);
                        }
                    }
                };
            });

            const eventId = computed(() => root.$route.params.eventId);
            
            const overlay = ref(false);
            
            const dialog = ref(false);
            const dialogMsg = ref('');
            
            const dbColMapping = eConfig.evoucher.dbColMapping;
            
            const readXLSX = (file) => {
                let nameSplit = file.name.split('.');
                let format = nameSplit[nameSplit.length - 1];
                if (!['xls', 'xlsx', 'csv'].includes(format)) {
                    return false;
                }
                return new Promise((resolve) => {
                    let reader = new FileReader();
                    reader.readAsBinaryString(file);
                    reader.onload = function (evt) {
                        let data = evt.target.result;
                        var workbook = XLSX.read(data, {type: 'binary'});
                        let outdata = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], {defval: ''});
                        resolve(outdata);
                    }
                });
            }

            const uploadExcel = async (f) => {
                if (f) {
                    const outdata = await readXLSX(f);
                    excelData.value = outdata;
                } else {
                    excelData.value = JSON.parse(JSON.stringify(excelData_init));
                }
                return false;
            };
            
            const checkValue = (header, value) => {
                if (header == 'Guest Username' && value.toString().trim() == '') {
                    return false;
                }
                if (header == 'isDisabled (0/1)' && value !== header && !['', '0', '1'].includes(value.toString().trim())) {
                    return false;
                }
                return true;
            };
            
            const loadDataCheck = (e) => {
                if (!_.isEqual(excelData.value, excelData_init)) {
                    if (!checkValue(e.cell.header.name, e.cell.value)) {
                        e.ctx.fillStyle = '#FFAAAA';
                    }
                }
            };

            const importCheck = async () => {
                if (!excelData.value[0].hasOwnProperty('Merchant Username') || !excelData.value[0].hasOwnProperty('Guest Username')) {
                    root.$store.dispatch('showSnackBar', 'Missing Merchant Username or Guest Username columns');
                    return false;
                }
                
                for (let y = 0; y < excelData.value.length; y++) {
                    let rowValid = Object.keys(excelData.value[y]).every((header) => { return checkValue(header, excelData.value[y][header]); });
                    if (!rowValid) {
                        root.$store.dispatch('showSnackBar', 'Row #' + (y + 1) + ' is not valid');
                        return;
                    }
                }
                
                overlay.value = true; 

                let m;
                try {
                    m = await root.$store.dispatch('merchants/find', {
                        query: {
                            eventId: eventId.value
                        }
                    });
                } catch (e) {
                    root.$handleFeatherError(e);
                }

                let eg;
                try {
                    eg = await root.$store.dispatch('event-guests/find', {
                        query: {
                            eventId: eventId.value
                        }
                    });
                } catch (e) {
                    root.$handleFeatherError(e);
                }

                m = m.reduce((merchants, { id, username }) => {
                    merchants[username] = id;
                    return merchants;
                }, {});

                eg = eg.data.reduce((eventGuests, { id, guests }) => {
                    eventGuests[guests.username] = id;
                    return eventGuests;
                }, {});

                let count = 0;
                let errorCount = 0;
                let errorMsg = '';

                for (let g of excelData.value) {
                    let temp;
                    const evoucherForAll = (g.hasOwnProperty('Merchant Username') && g['Merchant Username'] === '') ? true : false;
                    if (evoucherForAll) {
                        if (!eg[g['Guest Username']]) {
                            temp = 'Guest username does not exist';
                        }
                    } else {
                        if (!m[g['Merchant Username']] && !eg[g['Guest Username']]) {
                            temp = 'Guest username and Merchant username does not exist';
                        } else if (!eg[g['Guest Username']]) {
                            temp = 'Guest username does not exist';
                        } else if (!m[g['Merchant Username']]) {
                            temp = 'Merchant username does not exist';
                        }
                    }
                    count++;
                    if (temp) {
                        errorMsg += '<li>Row #' + count + ' - ' + temp + '</li>';
                        errorCount++;
                    }
                }

                if (errorCount) {
                    overlay.value = false;
                    dialogMsg.value = 'No record is imported, please check below error(s):<br><ul>' + errorMsg + '</ul>';
                    dialog.value = true;
                    return;
                }

                count = 0;
                errorCount = 0;
                errorMsg = '';
                
                for (let g of excelData.value) {
                    // post process data
                    if (g.hasOwnProperty('Merchant Username') && g['Merchant Username']) g['Merchant Username'] = g['Merchant Username'].toString().trim();
                    if (g.hasOwnProperty('Merchant Username') && g['Merchant Username'] === '') g['Merchant Username'] = null;
                    if (g.hasOwnProperty('Guest Username') && g['Guest Username']) g['Guest Username'] = g['Guest Username'].toString().trim();
                    if (g.hasOwnProperty('Day') && g['Day']) g['Day'] = g['Day'].toString().trim();
                    if (g.hasOwnProperty('Location') && g['Location']) g['Location'] = g['Location'].toString().trim();
                    if (g.hasOwnProperty('isDisabled (0/1)') && g['isDisabled (0/1)']) g['isDisabled (0/1)'] = g['isDisabled (0/1)'].toString().trim();
                    if (g.hasOwnProperty('isDisabled (0/1)') && g['isDisabled (0/1)'] === '') g['isDisabled (0/1)'] = '0';
                    
                    let $_EventEvoucher = new EvoucherGuest();
                    $_EventEvoucher.eventId = eventId.value;
                    $_EventEvoucher.merchantId = m[g['Merchant Username']];
                    $_EventEvoucher.eventGuestId = eg[g['Guest Username']];
                    $_EventEvoucher.day = g['Day'];
                    $_EventEvoucher.location = g['Location'];
                    $_EventEvoucher.is_used = '0';
                    $_EventEvoucher.is_disabled = g['isDisabled (0/1)'];

                    let temp;
                    temp = await $_EventEvoucher.save().then(() => {
                        return false;
                    }, (e) => {
                        // root.$handleFeatherError(e);
                        return e.errors ? e.errors.map ? (e.errors.map(a => a.message)).join('; ') : e.message : e.statusText;
                    });
                    count++;
                    if (temp) {
                        errorMsg += '<li>Row #' + count + ' - ' + temp + '</li>';
                        errorCount++;
                    }
                }
                
                overlay.value = false;
                if (errorCount) {
                    dialogMsg.value = (count - errorCount) + ' of ' + count + ' Evoucher(s) sucessfully created.<br><br>' + (errorCount) + ' of ' + count + ' Evoucher(s) NOT created:<br><ul>' + errorMsg + '</ul>';
                    dialog.value = true;
                } else {
                    dialogMsg.value = '';
                    root.$store.dispatch('showSnackBar', 'Success. ' + count + ' Evoucher(s) Created.' + errorMsg);
                    root.$router.replace({name: 'evoucher-guests'});
                }
            };
            
            const excelData_init = [{
                ...Object.keys(dbColMapping).reduce((reduced, key) => ({ ...reduced, [key]: '' }), {})
            }];
            const excelData = ref(JSON.parse(JSON.stringify(excelData_init)));
            
            const beforeSortColumn = (e) => {
                e.preventDefault();
            };
            
            const addEvoucher = () => {
                document.getElementById('excelGrid').addRow({});
            };
            
            const removeEvoucher = () => {
                let rowSelected = document.getElementById('excelGrid').selectedRows.map((row, j) => !!row && j).filter(j => j !== false && j >= 0).reverse();
                if (rowSelected.length >= 1 && document.getElementById('excelGrid').selections.every(row => !row || !row.length || row.length === document.getElementById('excelGrid').columnOrder.length + 1)) {
                    if (excelData.value.length - rowSelected.length >= 1) {
                        rowSelected.forEach(j => document.getElementById('excelGrid').deleteRow(j));
                    } else {
                        excelData.value = JSON.parse(JSON.stringify(excelData_init));
                    }
                } else {
                    root.$store.dispatch('showSnackBar', 'Please select entire row(s) by clicking row number.');
                }
            };
            
            return {
                CanvasDatagrid,
                uploadExcel,
                excelData,
                importCheck,
                loadDataCheck,
                overlay,
                beforeSortColumn,
                addEvoucher,
                removeEvoucher,
                dialogMsg,
                dialog,
            }
        },
    }
</script>